// extracted by mini-css-extract-plugin
export default {"l_ProductList_flexContainer":"ProductList_l_ProductList_flexContainer__71sND"};